import { useEffect, useRef } from "react";

export function useInfiniteScroll(
  canLoadMore: boolean,
  loadMore: (numItems: number) => void,
  pageSize: number
) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!canLoadMore || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          loadMore(pageSize);
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [canLoadMore, loadMore, pageSize]);

  return sentinelRef;
}
